module.exports = __webpack_public_path__ + "static/media/motorcycle.533a9da6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/motorcycle.svg
// module id = 2789
// module chunks = 0